module.exports = __webpack_public_path__ + "media/images/dashboard-badge-8fe9dca8.png";